import { render, staticRenderFns } from "./delete-user.vue?vue&type=template&id=bb1f4dde&scoped=true&"
import script from "./delete-user.vue?vue&type=script&lang=js&"
export * from "./delete-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1f4dde",
  null
  
)

export default component.exports